'use strict';

angular.module('app')
  .service('DiveSite', function($http, $location, $rootScope, $timeout, $routeParams, $q, utils, Request, config) {
    var DiveSite = {},
      _this = this;

    DiveSite.getDS = function(slug) {
      return Request.get('places/dive-sites/' + slug + '/').then(function(res) {
        return res.data;
      }, function(err) {
        return err;
      });
    }

    DiveSite.generatePin = function(item, scope) {
      return {
        lat: item.latitude,
        lng: item.longitude,
        icon: config.mapIcons.diveSites,
        info: {
          backgrounds: item.thumbnails,
          title: item.title,
          rating: item.rating,
          hideBtn: true
        },
        focus: true,
        getMessageScope: function() {
          return scope;
        },
        message: '<div ng-include src=\'"templates/_ds-popup.html"\'></div>'
      };
    }

    DiveSite.reviews = function(newPageLink) {
      var link = 'places/dive-sites/' + $routeParams.slug + '/votes/',
        query = {
          page_size: 3
        };
      if (newPageLink) {
        link = newPageLink;
        query = {};
      }
      return Request.get(link, query, newPageLink).then(function(rating) {
        return rating.data;
      });
    }

    DiveSite.addReview = function(data, timeout) {
      var diveSiteSlug = $routeParams.slug || data.diveSiteSlug,
        link = 'places/dive-sites/' + diveSiteSlug + '/votes/';

      data.diveSiteSlug = diveSiteSlug;

      return Request.post(link, data).then(function(rating) {
        if (timeout) {
          $timeout(function() {
            $rootScope.showNotify('Your review was successfully added');
          }, 4500);
        } else {
          $rootScope.showNotify('Your review was successfully added');
        }
        return rating.data;
      });
    };

    DiveSite.statistic = function() {
      var link = 'places/dive-sites/' + $routeParams.slug + '/stats/';

      return Request.get(link).then(function(res) {
        var graphs = {
          visibility: [],
          underWaterTemp: [],
          logsPerMonth: [],
          underWaterTempAvg: [],
          visibilityYearlyAvg: []
        },
          noVisibility = 0,
          noWaterTemp = 0,
          noReviews = 0;

          console.log(res.data.logsPerMonth)

        for (var i = 1; i <= 12; i++) {
          var underwater = parseFloat(parseFloat(res.data.underwaterTemperatureYearlyAvg).toFixed(2)),
              visibility = parseFloat(parseFloat(res.data.visibilityYearlyAvg).toFixed(2));

          graphs.underWaterTempAvg.push(_.isNumber(underwater) ? underwater : 0);
          graphs.visibilityYearlyAvg.push(_.isNumber(visibility) ? visibility : 0);

          if (res.data.underwaterTemperaturePerMonth[i] === null) {
            noWaterTemp++;
          }

          if (res.data.visibilityPerMonth[i] === null) {
            noVisibility++;
          }

          if (res.data.logsPerMonth[i] === null) {
            noReviews++;
          }

          graphs.underWaterTemp.push(parseFloat(parseFloat(res.data.underwaterTemperaturePerMonth[i] || 0).toFixed(2)));
          graphs.logsPerMonth.push(res.data.logsPerMonth[i]);
          graphs.visibility.push(parseFloat(parseFloat(res.data.visibilityPerMonth[i] || 0).toFixed(2)));
        }
        if (noWaterTemp === 12) {
          graphs.underWaterTemp = [];
        }

        if (noVisibility === 12) {
          graphs.visibility = [];
        }

        if (noReviews === 12) {
          graphs.logsPerMonth = [];
        }

        return graphs;



      });
    }

    DiveSite.getShops = function(info, scope) {
      var link = 'places/dive-sites/' + $routeParams.slug + '/shops/';

      return Request.get(link).then(function(res) {
        var pins = [];
        _.each(res.data, function(val) {
          if (val.point && val.point.length) {
            pins.push({
              lat: val.point[1],
              lng: val.point[0],
              icon: config.mapIcons.withPrice,
              info: val,
              getMessageScope: function() {
                return scope;
              },
              message: '<div ng-include src=\'"templates/_ds-popup.html"\'></div>'
            });
          }
        });

        var dsPin = DiveSite.generatePin(info, scope);
        if (dsPin.lat && dsPin.lng) {
          pins.push(dsPin);
        }

        return pins;
      });
    };

    DiveSite.getPhotos = function() {
      return Request.get('images/dive-sites/' + $routeParams.slug + '/').then(function(res) {
        var screenWidth = $(window).innerWidth(),
          goodQuality = screenWidth - (screenWidth * 0.35),
          data = {
            badImages: [],
            goodImages: [],
            allPhotos: res.data.results
          };

        _.each(res.data.results, function(val, key) {
          if (val.width < goodQuality) {
            data.badImages.push(val);
          } else {
            data.goodImages.push(val);
          }
        });

        return data;
      })
    }

    return DiveSite;
  });